

export const SET_FIELD_VALUE = "SET_FIELD_VALUE";
export const SET_TRANSFER_LOADING = "SET_TRANSFER_LOADING";
export const SET_TRANSFER_MESSAGE = "SET_TRANSFER_MESSAGE";
export const SET_TRANSFER_ERRORS = "SET_TRANSFER_ERRORS";
export const RESET_INITIAL_TRANSFER_STATE = "RESET_INITIAL_TRANSFER_STATE";
export const RESET_TRANSFER_MESSAGE = "RESET_TRANSFER_MESSAGE";
export const RESET_AND_SET_TYPE = "RESET_AND_SET_TYPE";
export const SET_UPLOAD_CONFIG = "SET_UPLOAD_CONFIG";

export const DEFAULT_ALLOWED_FILE_TYPES = 'zip,json';
export const DEFAULT_MAX_FILE_SIZE_GB = 5;

export const TRANSFER_API_TIMEOUT = 60000;

export const TRANSFER_TYPE_RAP = 'rap';
export const TRANSFER_TYPE_FIREWALL = 'firewall';
export const DEVICE_TYPE_IOT_GATEWAY = 'IoTGateway';
export const DEVICE_TYPE_FIREWALL = 'Firewall';

